// Generated by script, don't edit it please.
import createSvgIcon from '../../createSvgIcon';
import AngleDownSvg from '@rsuite/icon-font/lib/legacy/AngleDown';
var AngleDown = createSvgIcon({
    as: AngleDownSvg,
    ariaLabel: 'angle down',
    category: 'legacy',
    displayName: 'AngleDown'
});
export default AngleDown;
